import React, { useState } from 'react';
import { FloatButton, Tooltip } from 'antd';
import { DollarCircleOutlined, QuestionCircleOutlined, EditOutlined } from '@ant-design/icons';
import config from 'config'
import FeedbackModal from '../Feedback';
import { submitFeedback } from '@/apis';
import giftBox from './gift-box.png'
import './styles.less'

const wenjuanUrl = 'https://ncncjm75xkdw.feishu.cn/share/base/form/shrcnD6Yq9MO4HTDjj7YVjE7fPe'
const helpCenterUrl = config.domain + '/help_center'
const inviteUrl = config.domain + '/invite-center'

export const Support = () => {
  const [feedbackVisible, setFeedbackVisible] = useState(false)
  const prefixCls = 'support'
  return (
    <>
      <FloatButton.Group shape="circle" style={{ right: 24 }}>
        <img 
          src={giftBox} 
          alt="gift-box" 
          className={`${prefixCls}-gift`} 
          onClick={() => setFeedbackVisible(true)}
        />
        <Tooltip title="邀请有礼" placement="left">
          <FloatButton
            icon={<DollarCircleOutlined />}
            href={inviteUrl}
            target="_blank"
          />
        </Tooltip>
        <Tooltip title="填写问卷" placement="left">
          <FloatButton
            icon={<EditOutlined />}
            href={wenjuanUrl}
            target="_blank"
          />
        </Tooltip>
        <Tooltip title="帮助教程" placement="left">
          <FloatButton
            icon={<QuestionCircleOutlined />}
            href={helpCenterUrl}
            target="_blank"
          />
        </Tooltip>
        <FloatButton.BackTop visibilityHeight={800} />
      </FloatButton.Group>
      <FeedbackModal
        visible={feedbackVisible}
        onClose={() => setFeedbackVisible(false)}
        onSubmit={async (values) => { 
          console.log(values)
          await submitFeedback(values)
        }}
      />
    </>
  )
}
